import { useEffect, useState } from "react"
import { IoSearchOutline } from "react-icons/io5"
import ApiClient from "../../methods/api/apiClient"
import { useParams } from "react-router-dom"
import moment from "moment"
import methodModel from "../../methods/methods"
import Layout from "../../components/global/layout"

const BlogDetails = () => {
    const { id } = useParams()
    const [detail, setDetail]: any = useState()

    useEffect(() => {
        getDetails()
    }, [])

    const getDetails = () => {
        ApiClient.get(`blog/detail?id=${id}`).then((res: any) => {
            if (res.success) {
                setDetail(res.data)
            }
        })
    }

    return (
        <>

        <Layout>
        <div><img src={methodModel.noImg(detail?.image)} className="w-full h-96 object-cover" /></div>
        <div className="wrapper_section py-6 lg:py-16 px-6 lg:px-16 ">
                
           
            <div className="grid grid-cols-12 gap-6 ">
               
                <div className="col-span-12 ">
                    <div className="flex flex-col gap-2 justify-between">
                        <h2 className="text-xl lg:text-3xl font-bold  capitalize">{detail?.title}</h2>
                        <h2 className="text-lg font-medium mb-2 capitalize">{detail?.addedBy?.fullName || detail?.addedBy?.firstName} || {moment(detail?.createdAt).format("LL")}</h2>
                    </div>
                    <div className="mt-4">
                    <p className="text-md" dangerouslySetInnerHTML={{ __html: detail?.description }}></p>
                    </div>
                </div>
            </div>
            </div>
            </Layout>
        </>
    )
}

export default BlogDetails